import { z } from 'zod'

export const MENTORING_OFFER_EMAIL_DELIVERY = {
  SENT: 'sent',
  FAILED: 'failed'
} as const

export const UpsertMentoringOfferOutputDTOZ = z.object({
  offerId: z.uuid(),
  /** The `/mentoring/<id>` path staff copies and hands to the buyer. */
  offerPath: z.string(),
  /** Absolute URL shown to staff, e-mailed to the buyer and later stored in CRM. */
  offerUrl: z.url(),
  /** A failed provider call never hides the durable link from staff. */
  emailDelivery: z.enum(Object.values(MENTORING_OFFER_EMAIL_DELIVERY))
})

export type UpsertMentoringOfferOutputDTO = z.infer<typeof UpsertMentoringOfferOutputDTOZ>
